module.exports = __webpack_public_path__ + "media/images/logo-where-0f26f4993aa8470e3f5fdd23b5c3975f.svg";